'use client';

import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["component", "href", "disabled", "role", "onClick", "className"];
import React, { useContext } from 'react';
import cx from 'classnames';
import { BrowserDefaultFocusStyleContext } from "../../contexts/BrowserDefaultFocusStyleContext.mjs";
import { KeyboardDetectionContext } from "../../contexts/KeyboardDetectionContext.mjs";
import { ENCORE_DATA_IDS } from "../../dataEncoreIds.mjs";
import { PopoverMobileContext } from "../PopoverNavigation/index.mjs";
import { Link } from "./Link.mjs";
import { textClass } from "../../styles/layout-theme.mjs";
/**
 * PopoverNavigationLinks are links in the PopoverNaviagationList.
 *
 * [Storybook](https://encore-web.spotify.net/?path=/docs/components-popovernavigation-popovernavigationlink--docs) |
 * [Encore site](https://encore.spotify.net/web/components/popover#navigation-popover) |
 * [Github](https://ghe.spotify.net/encore/web/tree/master/src/core/components/PopoverNavigationLink) |
 * [Figma](https://www.figma.com/design/bnQXqGkLeiTlbk8JXGDcsX/%E2%9A%99%EF%B8%8F-%E2%80%8A%E2%80%8BEncore-Web-Components?m=auto&node-id=32403-12481&t=p9BSbkCzNpWDGLQr-1)
 */
export var PopoverNavigationLink = /*#__PURE__*/React.forwardRef(function PopoverNavigationLink(_ref, ref) {
  var component = _ref.component,
    href = _ref.href,
    disabled = _ref.disabled,
    role = _ref.role,
    onClick = _ref.onClick,
    className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useContext = useContext(KeyboardDetectionContext),
    isUsingKeyboard = _useContext.isUsingKeyboard;
  var _useContext2 = useContext(BrowserDefaultFocusStyleContext),
    useBrowserDefaultFocusStyle = _useContext2.useBrowserDefaultFocusStyle;
  var _useContext3 = useContext(PopoverMobileContext),
    isMobile = _useContext3.isMobile;
  var encoreComponent = onClick ? 'button' : 'a';
  var isAnchorTag = encoreComponent === 'a' || component === 'a';
  var encoreRole = disabled && isAnchorTag ? 'link' : undefined;
  return /*#__PURE__*/React.createElement(Link, Object.assign({
    ref: ref,
    component: component || encoreComponent,
    onClick: onClick,
    href: !disabled ? href : undefined,
    disabled: disabled,
    "aria-disabled": disabled,
    isUsingKeyboard: isUsingKeyboard,
    useBrowserDefaultFocusStyle: useBrowserDefaultFocusStyle,
    "data-encore-id": ENCORE_DATA_IDS.PopoverNavigationLink,
    role: role || encoreRole,
    className: cx(className, textClass(isMobile ? 'bodyMediumBold' : 'bodySmall'))
  }, props));
});